export default __webpack_public_path__ + "static/media/police.89aa6ecb.jpg";